module.exports = __webpack_public_path__ + "static/media/ZECHEK.493f1ca1.svg";